<template>
  <div class="subPatternCard">
    <div class="subPatternCardBody">
      <v-layout
        row
        wrap
        :class="
          !['หัวข้อ'].includes(value.questiontype)
            ? 'patternOption'
            : !['บทความ'].includes(value.questiontype)
            ? 'patternTopicOption'
            : 'patternSingleOption'
        "
      >
        <v-flex xs12 class="mb-3">
          <div style="display: flex; align-items: center">
            <div
              class="form-control"
              style="width: 95%; display: flex;"
              :class="{ 'has-error': errors.has('คำถามย่อย' + dataindex) }"
            >
              <template v-if="value.questiontype == 'บทความ'">
                <textarea
                  :name="'คำถามย่อย' + dataindex"
                  :data-vv-as="value.questiontype"
                  v-validate="'required'"
                  :value="value.name"
                  @input="update('name', $event.target.value)"
                  placeholder="กรอกบทความ"
                  type="text"
                  class="rsu mb-0"
                  rows="6"
                  style="height: auto !important;padding: 12px !important;margin: 0;resize: none;"
                />
              </template>
              <template v-else>
                <img
                  v-if="value.questiontype == 'หัวข้อ'"
                  :src="`/static/img/assets/menuIcons/${typeIcon('หัวข้อ')}.svg`"
                  alt
                  class="responsive-img mr-2"
                />
                <input
                  :name="'คำถามย่อย' + dataindex"
                  :data-vv-as="value.questiontype"
                  v-validate="'required'"
                  :value="value.name"
                  @input="update('name', $event.target.value)"
                  :placeholder="`เพิ่ม${value.questiontype}`"
                  type="text"
                  :class="
                    `depainput rsu mb-0 ${
                      ['หัวข้อ'].includes(value.questiontype) ? 'questiontypeTopicInput' : null
                    }`
                  "
                />
              </template>
            </div>
            <v-btn @click="$emit('ondelete')" icon class="ma-0 ml-3">
              <img src="/static/img/delete.png" alt class="responsive-img" style="height: 20px" />
            </v-btn>
          </div>
          <div>
            <span class="text-error" v-if="errors.has('คำถามย่อย' + dataindex)">{{
              errors.first('คำถามย่อย' + dataindex)
            }}</span>
          </div>
        </v-flex>
        <v-flex xs8 class="mb-2" v-show="!['หัวข้อ'].includes(value.questiontype)" style="display: flex;align-items: center;">
          <v-menu>
            <template #activator="{ on: menu }">
              <div style="cursor: pointer;display:flex;width: 95%;" v-on="menu">
                <div style="position: relative" class="form-control d-flex align-center w-100">
                  <div style="position: absolute;left: 12px;height: 20px;">
                    <img
                      :src="`/static/img/assets/menuIcons/${typeIcon(value.questiontype)}.svg`"
                      alt
                      class="responsive-img"
                    />
                  </div>
                  <input
                    :value="value.questiontype"
                    readonly
                    type="text"
                    class="depainput rsu"
                    style="padding-left: 40px !important; cursor: pointer;margin-bottom: 0;"
                  />
                  <i
                    style="color: grey; position: absolute; right: 10px; top: 10px"
                    class="fas fa-chevron-down"
                  ></i>
                </div>
              </div>
            </template>
            <v-list>
              <v-list-tile
                class="rsu"
                v-for="(item, index) in optionsStatus"
                :key="index"
                @click="selectOptionStatus(item)"
              >
                <v-list-tile-title>
                  <div
                    style="color: #152d53;display: flex;justify-content: flex-start;align-items: center;"
                  >
                    <img
                      :src="`/static/img/assets/menuIcons/${typeIcon(item)}.svg`"
                      alt
                      class="responsive-img mr-2"
                      style="height: 20px;"
                    />
                    {{ item | filterStatus }}
                  </div>
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-flex>
        <v-flex xs4 class="mb-2" style="display: flex;align-items: center;">
          <div class="d-flex">
            <v-checkbox
              v-if="!['หัวข้อ', 'บทความ'].includes(value.questiontype)"
              v-model="nativecheckbox"
              @change="update('isRequired', $event)"
              class="mt-0 optionCheckBox checkDf"
              color="primary"
              label="จำเป็น"
            ></v-checkbox>
          </div>
        </v-flex>
        <v-flex
          v-if="
            !['ข้อความ', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น', 'หัวข้อ', 'บทความ'].includes(
              value.questiontype
            )
          "
          xs12
          class="pr-0 rsu"
        >
          <div
            v-for="(item, k) in value.fields"
            :key="k"
            class="default-input mb-2"
            style="display: flex; align-items: center"
          >
            <div style="width: 100%;" class="rsu">
              <v-text-field
                :name="'ตัวเลือก' + dataindex + k"
                :data-vv-as="'ตัวเลือก'"
                :placeholder="'ตัวเลือก ' + (k + 1)"
                :error-messages="errors.first('ตัวเลือก' + dataindex + k)"
                v-validate="'required'"
                v-model="value.fields[k].label"
                class="option-input rsu"
                single-line
                append-icon="mdi-close"
                style="height: 35px !important;width: 69.3%;"
                @click:append="deleteItem(k)"
              >
                <template v-slot:prepend>
                  <div style="color: #152d53 mr-4">
                    <img
                      :src="`/static/img/assets/menuIcons/${typeIcon(value.questiontype)}.svg`"
                      alt
                      class="responsive-img mr-2"
                      style="height: 20px;"
                    />
                  </div>
                </template>
              </v-text-field>
              <div v-if="['ช่องทำเครื่องหมาย'].includes(value.questiontype)">
                <div
                  :key="dataindex + k + '' + index"
                  v-for="(form, index) in value.fields[k].subquestion"
                >
                  <FormitemSubquestion
                    @onMove="onMoveForm"
                    :formlength="value.fields[k].subquestion.length"
                    :dataindex="index"
                    @ondelete="ondelete(index, k)"
                    v-model="value.fields[k].subquestion[index]"
                  ></FormitemSubquestion>
                </div>
                <div class="text-xs-right">
                  <v-btn @click="addsubquestion(k)" small color="primary">เพิ่มคำถาม</v-btn>
                </div>
              </div>
            </div>
          </div>
          <div style="display: flex; align-items: center">
              <img
                :src="`/static/img/assets/menuIcons/${typeIcon(value.questiontype)}.svg`"
                alt
                class="responsive-img mr-2"
                style="height: 20px;"
              />
              <input
                @keyup.enter="onBlurMorefield"
                @blur="onBlurMorefield"
                v-model="morefield_input"
                placeholder="เพิ่มตัวเลือกหรืออื่นๆ"
                class="borderInput rsu mb-0"
                style="height: 32px !important;width: 54.2%;"
              />
          </div>
        </v-flex>
        <v-flex xs12 v-if="['อัปโหลดลายเซ็น', 'อัปโหลดไฟล์'].includes(value.questiontype)">
          <div class="checkUpload">
            <v-checkbox
              color="primary"
              v-model="value.isMultiple"
              label="Multiple File"
            ></v-checkbox>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <!-- <v-card class="pa-2" style="position: relative; background-color: #f7f7f7" outline>
      <div style="position: absolute; right: -10px; top: -9px" class="text-xs-right">
        <v-btn @click="$emit('ondelete')" icon>
          <v-icon color="#d84d4d">delete</v-icon>
        </v-btn>
      </div>
      <v-layout class="ma-0" row wrap>
        <v-flex class="pl-2" xs11>
          <v-layout row wrap class="mb-0">
            <v-flex xs12 class="mb-3">
              <div style="display: flex; align-items: center">
                <div
                  class="form-control"
                  style="width: 95%"
                  :class="{ 'has-error': errors.has('คำถาม' + dataindex) }"
                >
                  <template v-if="value.questiontype == 'บทความ'">
                    <textarea
                      :name="'คำถาม' + dataindex"
                      :data-vv-as="'คำถาม'"
                      v-validate="'required'"
                      :value="value.name"
                      @input="update('name', $event.target.value)"
                      placeholder="กรอกคำถาม"
                      type="text"
                      class="rsu mb-0"
                      style="height: 101px !important"
                    />
                  </template>
                  <template v-else>
                    <input
                      :name="'คำถาม' + dataindex"
                      :data-vv-as="'คำถาม'"
                      v-validate="'required'"
                      :value="value.name"
                      @input="update('name', $event.target.value)"
                      placeholder="กรอกคำถาม"
                      type="text"
                      class="depainput form-control rsu mb-0"
                    />
                  </template>
                  <span class="text-error" v-if="errors.has('คำถาม' + dataindex)">{{
                    errors.first('คำถาม' + dataindex)
                  }}</span>
                </div>
              </div>
            </v-flex>
            <v-flex xs6>
              <v-menu>
                <template #activator="{ on: menu }">
                  <div style="cursor: pointer" v-on="menu">
                    <div style="position: relative" class="form-control">
                      <input
                        :value="value.questiontype"
                        readonly
                        type="text"
                        class="depainput rsu"
                        style="padding-left: 40px !important; cursor: pointer"
                      />
                      <div style="position: absolute; top: 6px; left: 12px">
                        <v-icon color="#152d53">{{ typeIcon(value.questiontype) }}</v-icon>
                      </div>
                      <i
                        style="color: grey; position: absolute; right: 10px; top: 10px"
                        class="fas fa-chevron-down"
                      ></i>
                    </div>
                  </div>
                </template>
                <v-list>
                  <v-list-tile
                    class="rsu"
                    v-for="(item, index) in optionsStatus"
                    :key="index"
                    @click="selectOptionStatus(item)"
                  >
                    <v-list-tile-title>
                      <div style="color: #152d53">
                        <v-icon color="#152d53">{{ typeIcon(item) }}</v-icon>
                        {{ item | filterStatus }}
                      </div>
                    </v-list-tile-title>
                  </v-list-tile>
                </v-list>
              </v-menu>
            </v-flex>
            <v-flex xs6>
              <v-checkbox
                v-if="!['หัวข้อ', 'บทความ'].includes(value.questiontype)"
                v-model="nativecheckbox"
                @change="update('isRequired', $event)"
                class="mt-0 ml-3"
                color="primary"
                label="จำเป็น"
              ></v-checkbox>
            </v-flex>
            <v-flex
              v-if="
                !['ข้อความ', 'อัปโหลดไฟล์', 'อัปโหลดลายเซ็น', 'หัวข้อ', 'บทความ'].includes(
                  value.questiontype
                )
              "
              xs12
              class="px-5 rsu"
            >
              <div
                v-for="(item, k) in value.fields"
                :key="k"
                class="default-input mb-2"
                style="display: flex; align-items: center"
              >
                <div style="width: 100%; margin-left: 5px" class="rsu">
                  <v-text-field
                    :name="'ตัวเลือก' + dataindex + k"
                    :data-vv-as="'ตัวเลือก'"
                    v-validate="'required'"
                    append-icon="close"
                    v-model="value.fields[k].label"
                    @click:append="deleteItem(k)"
                    :placeholder="'ตัวเลือก ' + (k + 1)"
                    single-line
                    :error-messages="errors.first('ตัวเลือก' + dataindex + k)"
                    class="default-input rsu"
                  >
                    <template v-slot:prepend>
                      <div style="color: #152d53 mr-4">
                        <v-icon class="mb-3 mt-1" size="17" color="#152d53">{{
                          typeIcon(value.questiontype)
                        }}</v-icon>
                      </div>
                    </template>
                  </v-text-field>
                  <div v-if="['ช่องทำเครื่องหมาย'].includes(value.questiontype)">
                    <div
                      :key="dataindex + k + '' + index"
                      v-for="(form, index) in value.fields[k].subquestion"
                    >
                      <FormitemSubquestion
                        @onMove="onMoveForm"
                        :formlength="value.fields[k].subquestion.length"
                        :dataindex="index"
                        @ondelete="ondelete(index, k)"
                        v-model="value.fields[k].subquestion[index]"
                      ></FormitemSubquestion>
                    </div>
                    <div class="text-xs-right">
                      <v-btn @click="addsubquestion(k)" small color="primary">เพิ่มคำถาม</v-btn>
                    </div>
                  </div>
                </div>
              </div>

              <div class="default-input" style="display: flex; align-items: center">
                <div style="color: #152d53 mr-4">
                  <v-icon class="mb-2" size="17" color="#152d53">{{
                    typeIcon(value.questiontype)
                  }}</v-icon>
                </div>

                <div style="margin-left: 5px; width: 100%">
                  <input
                    @keyup.enter="onBlurMorefield"
                    @blur="onBlurMorefield"
                    v-model="morefield_input"
                    style="border-bottom: none !important"
                    placeholder="เพิ่มตัวเลือกหรืออื่นๆ"
                    class="borderInput rsu"
                  />
                </div>
              </div>
            </v-flex>
            <v-flex xs12 v-if="['อัปโหลดลายเซ็น', 'อัปโหลดไฟล์'].includes(value.questiontype)">
              <div class="px-5">
                <v-checkbox
                  color="primary"
                  v-model="value.isMultiple"
                  label="Multiple File"
                ></v-checkbox>
              </div>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex xs1 class="pt-4">
          <div>
            <v-btn icon @click="onMoveForm('up')">
              <v-icon>keyboard_arrow_up</v-icon>
            </v-btn>
          </div>
          <div>
            <v-btn icon @click="onMoveForm('down')">
              <v-icon>keyboard_arrow_down</v-icon>
            </v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card> -->
  </div>
</template>

<script>
import Template from '../template/template.vue'
import FormitemSubquestion from './FormitemSubquestion.vue'
export default {
  components: { FormitemSubquestion, Template },
  props: {
    value: {
      default: null
    },
    formlength: { default: null },
    dataindex: { default: null }
  },
  inject: ['$validator'],
  data() {
    return {
      morefield_input: '',
      menu: false,
      subquestionDialog: false,
      nativecheckbox: this.value.isRequired,
      input: {
        name: '',
        questiontype: 'ช่องทำเครื่องหมาย',
        fields: [],
        isRequired: false,
        isMultiple: false,
        Options: '',
        digitPosition: 0
      },
      inputsubquestion: {
        name: '',
        questiontype: 'ช่องทำเครื่องหมาย',
        fields: [],
        isRequired: false,
        isMultiple: false,
        Options: '',
        digitPosition: 0
      },
      optionsStatus: [
        'ข้อความ',
        // 'หลายตัวเลือก',
        'เลื่อนลง',
        // 'ช่องทำเครื่องหมาย',
        'อัปโหลดไฟล์',
        'บทความ',
        'อัปโหลดลายเซ็น',
     
      ],
      currentKeySub: 0
    }
  },
  computed: {},
  mounted() {},
  methods: {
    ondelete(index, k) {
      // @ondelete="ondelete(index, k)"
      //             v-model="value.fields[k].subquestion[index]"
      this.value.fields[k].subquestion.splice(index, 1)
    },
    addsubquestion(k) {
      this.value.fields[k].subquestion.push({
        name: '',
        questiontype: 'ช่องทำเครื่องหมาย',
        fields: [],
        isRequired: false,
        isMultiple: false,
        Options: ''
      })
    },

    onMoveForm: function(direction) {
      var vm = this
      vm.$emit('onMove', this.dataindex, direction)
    },
    selectOptionStatus(item) {
      this.update('questiontype', item)
      this.$nextTick(() => {
        this.update('fields', [])
      })
    },
    update(key, value) {
      this.$emit('input', { ...this.value, [key]: value })
    },
    onBlurMorefield() {
      if (this.morefield_input) {
        this.value.fields.push({ label: this.morefield_input, subquestion: [] })

        this.$nextTick(() => {
          this.morefield_input = ''
        })
      }
    },
    typeIcon(item) {
      switch (item) {
        case 'ข้อความ':
          return 'textIco'
        case 'หลายตัวเลือก':
          return 'multiChoiceIco'
        case 'เลื่อนลง':
          return 'pushDownIco'
        case 'ช่องทำเครื่องหมาย':
          return 'markIco'
        case 'อัปโหลดไฟล์':
          return 'uploadFilesIco'
        case 'อัปโหลดลายเซ็น':
          return 'uploadSignIco'
        case 'หัวข้อ':
          return 'topicIco'
        case 'บทความ':
          return 'paragraphIco'
      }
    },
    addField() {
      this.input.fields.push('')
    },
    deleteItem(k) {
      this.value.fields.splice(k, 1)
    }
  },
  filters: {
    filterStatus: function(value) {
      switch (value) {
        case 'ข้อความ':
          return 'ข้อความ (text)'
        case 'หลายตัวเลือก':
          return 'หลายตัวเลือก (Multiple choice)'
        case 'ช่องทำเครื่องหมาย':
          return 'ช่องทำเครื่องหมาย (Checkboxes)'
        case 'เลื่อนลง':
          return 'เลื่อนลง (Choose from a list)'
        case 'อัปโหลดไฟล์':
          return 'อัปโหลดไฟล์ (Upload file)'
        case 'อัปโหลดลายเซ็น':
          return 'อัปโหลดลายเซ็น (Upload signature)'
        case 'หัวข้อ':
          return 'หัวข้อ (Title)'
        case 'บทความ':
          return 'บทความ (Paragraph)'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.text-error {
  color: red;
}
.subPatternCardBody {
  cursor: pointer;
  width: 77.8%;
  margin-left: 27px;
  border: 1px solid #beccdb;
  border-radius: 8px;
  .patternOption {
    padding: 20px 20px 10px 20px;
    margin: 0;
  }
  .patternSingleOption {
    padding: 20px 20px 10px 20px;
    border-radius: 0px 0px 8px 8px;
    margin: 0;
    background: #e6f0fb;
  }
  .patternTopicOption {
    padding: 20px 20px 10px 20px;
    border-radius: 8px;
    margin: 0;
    background: #ffffff;
  }
  .patternNoneOption {
    padding: 20px 20px 10px 20px;
    border-radius: 0px 0px 8px 8px;
    margin: 0;
    background: #e6f0fb;
  }
  .patternDetails {
    padding: 20px 20px 20px 20px;
    border-radius: 0px 0px 8px 8px;
    margin: 0;
    background: #ffffff;
    .v-text-field {
      padding-top: 0 !important;
      margin-top: 0 !important;
    }
  }
  .questiontypeTopicInput,
  .questiontypeTopicInput:focus,
  .questiontypeTopicInput:hover {
    border-right: 0 !important;
    border-left: 0 !important;
    border-top: 0 !important;
    border-radius: 0;
    font-family: 'Sukhumvit Set';
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    color: #26588b;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/projectMaster/FormitemSubquestion.vue